import _get from "lodash/get";
import _pick from "lodash/pick";
import _size from "lodash/size";
import { AnyAction } from "redux";
import * as AT from "./actionTypes";
import { PackagesState } from "../../../../models/state";
import { fulfilled, pending } from "../../app/utils";

const initialState: PackagesState = {
    availablePackages: [],
    isNoPackages: false,
};

const reducer = (state = initialState, action: AnyAction): PackagesState => {
    switch (action.type) {
        case pending(AT.FWA_LOOKUP_PACKAGES):
            return {
                ...initialState,
            };
        case fulfilled(AT.FWA_LOOKUP_PACKAGES):
            return {
                ...state,
                isNoPackages: _size(_get(action, "payload.availablePackages")) === 0,
                defaultTab: "FWA",
                ..._pick(_get(action, "payload"), ["availablePackages"]),
            };
        default:
            return state;
    }
};

export default reducer;
